// ======================================================================
// File Name       : UserList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import { connect } from 'react-redux';
import { Table, FormControl, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import TableHead, { setSortState } from '../../TableHead';
import * as distributionAction from '../../../actions/report/DistributionAction';
import PaginationCustom from '../../Pagination';

class UserList extends React.Component {
  constructor(props) {
    super(props);
    this.onChangeDistributionReportNum = this.onChangeDistributionReportNum.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
  }

  onChangeDistributionReportNum(userSecernId, event) {
    const { name, value } = event.target;
    if (name === 'distributionReportNum') {
      const { dispatch, distributionReport } = this.props;
      const { distributionReportDetail } = distributionReport;
      const { distributionEdittingReport, userListInfo } = distributionReportDetail;
      const { reportNum } = distributionEdittingReport;
      let reportNumAll = 0;
      // get report num of all user
      userListInfo.forEach((item) => {
        if (item.userSecernId !== userSecernId) {
          reportNumAll += item.distributionReportNum ? parseInt(item.distributionReportNum, 10) : 0;
        }
      });
      reportNumAll += parseInt(value, 10);
      if (value < 0 || reportNumAll > reportNum) {
        return;
      }
      userListInfo.forEach((item) => {
        if (item.userSecernId === userSecernId) {
          item.distributionReportNum = parseInt(value, 10);
        }
      });
      dispatch(distributionAction.updateDistributionReportDetailUserListInfo(userListInfo));
    }
  }

  /**
   * handle sorting data
   * @param {*} row
   */
  handleSortState(row) {
    const { dispatch, distributionReport } = this.props;
    const { distributionReportDetail } = distributionReport;
    const { searchInfo } = distributionReportDetail;
    searchInfo.userSortType = row.sortBy;
    searchInfo.ascendingDescendingSort = row.sortState;
    dispatch(distributionAction.updateDistributionReportDetailSearchInfo(searchInfo));
    dispatch(distributionAction.searchUser());
  }

  getStartEndData(startPosition) {
    const { dispatch, distributionReport } = this.props;
    const { distributionReportDetail } = distributionReport;
    const { searchInfo } = distributionReportDetail;
    searchInfo.startPosition = startPosition;
    dispatch(distributionAction.updateDistributionReportDetailSearchInfo(searchInfo));
    dispatch(distributionAction.searchUser());
  }

  render() {
    const { dispatch, distributionReportSearch, distributionReport } = this.props;
    const { distributionReportDetail } = distributionReport;
    const { userListInfo, userListIds } = distributionReportDetail;
    const { searchInfo } = distributionReportDetail;
    const { recordNum } = userListIds;
    const { startPosition } = searchInfo;
    // table head
    const thead = [
      { title: 'ログインID', sortBy: null },
      { title: 'ユーザー', sortBy: 0 },
      { title: '添削中レポート件数', sortBy: null },
      { title: '割当レポート件数', sortBy: null },
    ];
    let data = thead;
    if (searchInfo) {
      const sortBy = searchInfo.userSortType;
      const sortState = searchInfo.ascendingDescendingSort;
      data = setSortState(thead, sortBy, sortState);
    }
    const userTableData =
      userListInfo &&
      userListInfo.length > 0 &&
      userListInfo.map((userInfo, index) => (
        <tr key={index}>
          <td>{userInfo.loginId}</td>
          <td>{userInfo.userName}</td>
          <td>{userInfo.reportNum || 0}</td>
          <td>
            <FormControl
              className="margin-left-10"
              type="number"
              name="distributionReportNum"
              value={userInfo.distributionReportNum || 0}
              onChange={this.onChangeDistributionReportNum.bind(this, userInfo.userSecernId)}
            />
          </td>
        </tr>
      ));

    return <>
      <div id="userListTable">
        <Table striped hover>
          <thead>
            <TableHead data={data} handleSortState={this.handleSortState} />
          </thead>
          <tbody>
            {userTableData}
          </tbody>
        </Table>
      </div>
      <Col sm={12} className="d-flex justify-content-center">
        <PaginationCustom
          recordNum={recordNum}
          startPosition={startPosition}
          handlePageSelect={this.getStartEndData}
        />
      </Col>
    </>;
  }
}

const mapStateToProps = (state, ownProps) => {
  const { form, distributionReport } = state;
  return {
    distributionReport,
  };
};

export default connect(mapStateToProps)(UserList);
